import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "classes"];
import React from 'react';
import PropTypes from 'prop-types';
import { default as withStyles } from '../styles';
import { default as MuiDialogActions } from '@material-ui/core/DialogActions';
import { spacing30 } from '../styles/tokens';

var styles = function styles(theme) {
  var _root, _button;

  return {
    root: (_root = {
      display: 'flex',
      flexDirection: 'column',
      margin: 0,
      padding: 0
    }, _root[theme.breakpoints.up('sm')] = {
      justifyContent: 'flex-end',
      flexDirection: 'row'
    }, _root),
    spacing: {
      '& > button': (_button = {
        margin: spacing30 + " 0",
        width: '100%'
      }, _button[theme.breakpoints.up('sm')] = {
        margin: "0 " + spacing30,
        width: 'auto'
      }, _button[theme.breakpoints.down('xs')] = {
        '&:not(:first-child)': {
          marginLeft: 0 // since buttons are stacked in sm viewports, no need for margin

        }
      }, _button)
    }
  };
};
/**
 * DialogActions are controls that live within a Dialog.
 */


var DialogActions = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var children = props.children,
      classesProp = props.classes,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var classes = {
    root: classesProp.root,
    spacing: classesProp.spacing
  };
  return /*#__PURE__*/React.createElement(MuiDialogActions, _extends({
    classes: classes
  }, rest, {
    ref: ref
  }), children);
});
DialogActions.muiName = 'DialogActions';
DialogActions.displayName = 'DialogActions';
DialogActions.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the dialog actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
};
DialogActions.defaultProps = {
  disableSpacing: false
};
export default withStyles(styles, {
  index: 0
})(DialogActions);